import queryString from 'query-string'

export const getQueryParams = (decode = true) => {
  const query = window.location.search
  const hasPercentChar = query.includes('%')

  if (hasPercentChar && decode) {
    return queryString.parse(query, { decode: true })
  } else {
    return queryString.parse(query, { decode: false })
  }
}
